export default "__VITE_ASSET__Dk6qM19f__"